const gui = {}

export default gui